import { TariffOption, DetailselectionfieldList, AdditionalText } from './structured-content-models';
import { ContextType } from '../service/price-box-communication.service';

export class BausteinContentConfig {
  text: string;
  selectionFields: DetailselectionfieldList[];
  tariff: TariffOption;
  additionalText: AdditionalText;
  context: ContextType;
}
